































import { Component, Vue } from "vue-property-decorator"
import LoginAccountDetails from "./Login/LoginAccountDetails.vue"
import LoginSecurityCode from "./Login/LoginSecurityCode.vue"

@Component({
  components: {
    LoginAccountDetails,
    LoginSecurityCode,
  },
})
export default class Login extends Vue {
  step = 1

  beforeDestroy() {
    this.$store.commit("Auth/CLEAR_GUEST_STATE")
  }

  //   async beforeRouteEnter (to, from, next) {
  //     console.debug('LoginJWT.beforeRouteEnter')
  //     const isAuthenticated = await auth.isAuthenticated()
  //     console.debug('LoginJWT.beforeRouteEnter isAuthed')
  //     if (isAuthenticated) {
  //       return next( { path: '/' } )
  //     }
  //     next()
  //   }

  get isActivationSucceed() {
    return this.$route.query.activated
  }
}
